import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getShortTermDebt = (state) =>
    resolveProp('dashboard.data.creditReportInfo.currentShortTermDebt.amount', state) || 0;
const getShortTermDebtChange = (state) =>
    resolveProp('dashboard.data.creditReportInfo.changeInShortTermDebt.amount', state) || 0;
const getShortTermCreditLimit = (state) =>
    resolveProp('dashboard.data.creditReportInfo.currentShortTermCreditLimit.amount', state) || 0;
const getLongTermDebt = (state) =>
    resolveProp('dashboard.data.creditReportInfo.currentLongTermDebt.amount', state) || 0;
const getLongTermDebtChange = (state) =>
    resolveProp('dashboard.data.creditReportInfo.changeInLongTermDebt.amount', state) || 0;

export default createSelector(
    getShortTermDebt,
    getShortTermDebtChange,
    getShortTermCreditLimit,
    getLongTermDebt,
    getLongTermDebtChange,
    (shortTermDebt, shortTermDebtChange, shortTermCreditLimit, longTermDebt, longTermDebtChange) => ({
        shortTermDebt,
        shortTermDebtChange,
        shortTermCreditLimit,
        longTermDebt,
        longTermDebtChange,
    }),
);
